/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LayoutRegular from './layout-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LayoutRegular {...validProps} />;
}
SvgComponent.iconName = 'layoutRegular';

export const LayoutRegularIcon = svgIconWrapper(SvgComponent);
